import { SSC_SEM_API_URL } from "../../settings/config";
import {
  fetchTopKeywordsOverviewInProgress,
  fetchTopKeywordsOverviewSuccessful,
  fetchTopKeywordsOverviewFailed,
  fetchTopKeywordsInProgress,
  fetchTopKeywordsSuccessful,
  fetchTopKeywordsFailed,
  fetchTopKeywordsForDashboardInProgress,
  fetchTopKeywordsForDashboardFinished
} from "./creators";
import { getSelectedWebsiteGuid } from "../tracked_websites/selectors";
import { getOverview, getOffset } from "./selectors";
import { authRequest } from "../authorizedRequests";

const fetchTopKeywordsOverview = (domain, seoDb) => {
  return (dispatch, getState) => {
    const guid = getSelectedWebsiteGuid(getState());
    const apiUrl = `${SSC_SEM_API_URL}/top-keywords/overview?domain=${domain}&db=${seoDb}`;

    if (Object.keys(getOverview(getState())).length > 0) {
      return Promise.resolve();
    }

    dispatch(fetchTopKeywordsOverviewInProgress(guid, seoDb));

    return authRequest(apiUrl, dispatch, getState)
      .then(response => {
        dispatch(fetchTopKeywordsOverviewSuccessful(guid, seoDb, response));
        return Promise.resolve();
      })
      .catch(_ => {
        dispatch(fetchTopKeywordsOverviewFailed(guid, seoDb));
        return Promise.resolve();
      });
  };
};

const fetchTopKeywords = (domain, seoDb, orderBy, orderDir, offset = 0) => {
  return (dispatch, getState) => {
    const guid = getSelectedWebsiteGuid(getState());
    const apiUrl = `${SSC_SEM_API_URL}/top-keywords?domain=${domain}&db=${seoDb}&order_by=${orderBy}&order_dir=${orderDir}&offset=${offset}`;

    if (getOffset(getState(), `${seoDb}_${orderBy}_${orderDir}`) > offset) {
      return Promise.resolve();
    }

    dispatch(fetchTopKeywordsInProgress(guid, seoDb, orderBy, orderDir));

    return authRequest(apiUrl, dispatch, getState)
      .then(response => {
        dispatch(fetchTopKeywordsSuccessful(guid, seoDb, orderBy, orderDir, response.keywords, response["has_more"]));
        return Promise.resolve();
      })
      .catch(_ => {
        dispatch(fetchTopKeywordsFailed(guid, seoDb, orderBy, orderDir));
        return Promise.resolve();
      });
  };
};

export const fetchTopKeywordsForDashboard = (domain, seoDb, orderBy, orderDir) => {
  return dispatch => {
    dispatch(fetchTopKeywordsForDashboardInProgress(domain, seoDb));
    let topKeywordsPromises = [
      dispatch(fetchTopKeywordsOverview(domain, seoDb)),
      dispatch(fetchTopKeywords(domain, seoDb, orderBy, orderDir))
    ];
    Promise.all(topKeywordsPromises).finally(_ => dispatch(fetchTopKeywordsForDashboardFinished(domain, seoDb)));
  };
};

const reloadTopKeywords = (domain, seoDb) => {
  return (dispatch, getState) => {
    dispatch(fetchTopKeywordsOverview(domain, seoDb));

    dispatch(fetchTopKeywords(domain, seoDb, "tr", "desc", 0)); //TODO: should receive orderBy & orderDir
  };
};

export { fetchTopKeywordsOverview, fetchTopKeywords, reloadTopKeywords };
